import React from 'react';
import styled, { css } from 'styled-components';
import cn from 'classnames';
import { SelectArrow } from '@lt/components/icons-react/userflow';

import { MobileProps, SearchType } from '../../../../../../types';
import {
  mobileDefaultControlStyles,
  mobileHotelPageControlStyles,
  MobileLabel,
} from '../../../../../../styles';
import { SEARCH_TYPE_NAMES, LEFT_BORDER_CLASS } from '../../../../../../constants';

import { fieldParams, FieldParams } from '../../constants';

type DurationTripFieldProps = {
  name: string;
  icon?: React.ReactNode;
  value: string;
  placeholder: FieldParams['placeholder'];
  searchType: SearchType;
  placeholderText?: string;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  isActive: boolean;
  variant?: 'default' | 'hotel';
} & MobileProps;

export const DurationTripField = ({
  name,
  icon,
  value,
  isMobile,
  placeholder,
  isWizard,
  searchType,
  placeholderText,
  className,
  onClick,
  isActive,
  variant = 'default',
}: DurationTripFieldProps) => (
  <Container
    className={cn(LEFT_BORDER_CLASS, className)}
    $isWizard={isWizard}
    $isActive={isActive}
    onClick={onClick}
  >
    {isMobile && !isWizard && (
      <MobileLabel $variant={variant}>{placeholder(searchType, true)}</MobileLabel>
    )}
    <FakeInput id={name} $isMobile={isMobile} $isWizard={isWizard} $variant={variant}>
      {searchType === SEARCH_TYPE_NAMES.PACKAGE && (isWizard || !isMobile) && (
        <IconContainer>{icon}</IconContainer>
      )}
      {value ? (
        <Value>{value}</Value>
      ) : (
        <Placeholder>{placeholderText || placeholder(searchType, isMobile)}</Placeholder>
      )}
      {isMobile && !isWizard && <SelectArrow width="10px" />}
    </FakeInput>
  </Container>
);

const Container = styled.div<{
  $isWizard?: boolean;
  $isActive: boolean;
}>`
  ${({ $isWizard }) => !$isWizard && `width: 100%;`}
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
  min-width: 100px;
  font-weight: ${({ $isActive }) => ($isActive ? 'normal' : 'bold')};
`;

const FakeInput = styled.div<{
  $isMobile?: boolean;
  $isWizard?: boolean;
  $variant?: 'default' | 'hotel';
}>`
  display: flex;
  position: relative;
  align-items: center;
  background-color: #fff;
  padding: 16px 8px;
  font-size: 14px;
  line-height: 16px;

  ${({ $isMobile, $isWizard, $variant }) =>
    $isMobile
      ? css`
          ${mobileDefaultControlStyles};
          ${$variant === 'hotel' && mobileHotelPageControlStyles}
          ${!$isWizard &&
          `&:hover {
            border: none;
          }`}

          justify-content: space-between;
        `
      : css`
        &:not(:first-child):before {
          content: '';
          width: 1px;
          background-color: #fff;
        }

        &:not(:first-child):after {
          content: '';
          width: 1px;
          height: 40px;
          background-color: #e6e9ee;
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          margin: auto;
      `}

  ${({ $isWizard }) =>
    $isWizard &&
    css`
      background-color: transparent;
      width: auto;
      height: auto;
      padding: 4px 8px;
      border: none;
      justify-content: initial;
      font-weight: normal;

      // смещение текста даты вылета в режиме выбора дней в календаре в визарде
      &[id=${fieldParams.days[0].name}] {
        justify-content: end;
      }
    `}
`;

const Value = styled.span`
  color: inherit;
  border: none;
  cursor: inherit;
`;

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const Placeholder = styled(Value)`
  font-weight: normal;
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 4px;

  path {
    stroke: currentColor;
  }
`;
